import React from "react";
import { Box, Typography } from "@mui/material";
import { ReactComponent as NewRenovationIcon } from "../../../../assets/svg/NewRenovationIcon.svg";
import { ReactComponent as MwebDhiramIcon } from "../../../../assets/svg/MwebDhiramIcon.svg";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import moment from "moment";
import { ReactComponent as NewDesignIcon } from "../../../../assets/svg/NewDesignIcon.svg";

const MobileView = ({ details, getProjectDetails , handleClick}) => {
  const milestones = details?.milestone || [];

  return (
    <div style={mobileStyles.container}>
      <div style={mobileStyles.milestonesContainer}>
        {milestones?.map((milestone, index) => (
          <div key={milestone.id} style={mobileStyles.milestoneCard} onClick={() => handleClick(milestone)}>
            <div style={mobileStyles.milestoneHeader}>
              <div style={mobileStyles.milestoneInfo}>
                <Box
                  component="img"
                  src={
                    milestone?.milestone_image?.path ||
                    "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                  }
                  alt="Milestone"
                  style={mobileStyles.milestoneImage}
                />
                <div style={mobileStyles.milestoneText}>
                  <Typography style={mobileStyles.milestoneLabel}>
                    Milestone
                  </Typography>
                  <Typography style={mobileStyles.milestoneName}>
                    {milestone?.milestone_name || `Milestone ${index + 1}`}
                  </Typography>
                </div>
              </div>
             
            </div>

            <div style={mobileStyles.milestoneDetails}>
               <Box display="flex" alignItems="center" gap="5px">
                <Box display="flex" alignItems="center">
                  {milestone?.tags === "Design" ? (
                    <NewDesignIcon />
                  ) : (
                    <NewRenovationIcon />
                  )}
                </Box>
                <Box color="#949DAA" fontSize="12px">
                  {milestone?.tags}
                </Box>
              </Box>
            </div>

            <div style={mobileStyles.milestoneDates}>
              <div style={mobileStyles.dateItem}>
                <Typography style={mobileStyles.dateLabel}>Due Date</Typography>
                <Typography style={mobileStyles.dateValue}>
                  {milestone?.end_date
                    ? moment(milestone?.end_date).format("DD MMM, YYYY")
                    : "-"}
                </Typography>
              </div>
              <div style={mobileStyles.dateItem}>
                <Typography style={mobileStyles.dateLabel}>
                  Start Date
                </Typography>
                <Typography style={mobileStyles.dateValue}>
                  {milestone?.start_date
                    ? moment(milestone?.start_date).format("DD MMM, YYYY")
                    : "-"}
                </Typography>
              </div>
              <div style={mobileStyles.dateItem}>
                <Typography style={mobileStyles.dateLabel}>Amount</Typography>
                <Typography style={mobileStyles.amountValue}>
                  <MwebDhiramIcon />
                  &nbsp;
                  {formattedAmountWithoutAed(milestone?.amount || "-")}
                </Typography>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const mobileStyles = {
  container: {
    padding: "2vh 0",
    backgroundColor: "#fff",
    minHeight: "100vh",
  },
  financialSummary: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "16px",
    marginBottom: "16px",
  },
  financialItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  financialLabel: {
    fontSize: "12px",
    color: "#666",
    marginBottom: "4px",
  },
  financialValue: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#333",
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  statusSelect: {
    minWidth: "150px",
  },
  select: {
    fontSize: "14px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  viewToggle: {
    display: "flex",
    gap: "4px",
    backgroundColor: "#f0f0f0",
    borderRadius: "8px",
    padding: "2px",
  },
  toggleButton: {
    width: "32px",
    height: "32px",
    border: "none",
    backgroundColor: "transparent",
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  toggleButtonActive: {
    backgroundColor: "#0066cc",
    color: "#fff",
  },
  addMilestoneButton: {
    width: "100%",
    backgroundColor: "#0066cc",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "12px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    marginBottom: "16px",
  },
  milestonesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  milestoneCard: {
    backgroundColor: "#fff",
    borderRadius: "none",
    padding: "16px",
    borderBottom: "1px solid #D7D8D9",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  milestoneHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  milestoneInfo: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  milestoneImage: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    objectFit: "cover",
  },
  milestoneText: {
    display: "flex",
    flexDirection: "column",
  },
  milestoneLabel: {
    fontSize: "12px",
    color: "#666",
    marginBottom: "2px",
  },
  milestoneName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  },
  milestoneIcon: {
    width: "20px",
    height: "20px",
  },
  milestoneDetails: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  contractorInfo: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  contractorAvatar: {
    width: "24px",
    height: "24px",
  },
  contractorText: {
    display: "flex",
    flexDirection: "column",
  },
  contractorLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "1px",
  },
  contractorName: {
    fontSize: "12px",
    fontWeight: "500",
    color: "#333",
  },
  statusInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  statusLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  statusContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  statusDot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    border: "3px solid rgb(229, 229, 229)",
  },
  statusText: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
  },
  milestoneDates: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dateItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  dateLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  dateValue: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
  },
  amountValue: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
};

export default MobileView;
